module.exports = __webpack_public_path__ + "static/media/referral-image.0f916791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/referral-image.png
// module id = 1037
// module chunks = 2